import type SubjectAddress from '@Domain/Subjects/SubjectAddress';

class FetchSubjectUsers {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
	) {
		Object.freeze(this);
	}
}

export default FetchSubjectUsers;
